import { useQuery } from "@tanstack/react-query";
import { getCartDetailsPbf } from "../../../services/purchaseApi";

/**
 * Hook to get purchase cart
 * Will be called on refresh/initial loads
 * 
 * @returns cart to use on cart page and header
 */

export const UseCartQueryPbf = () => {
    return useQuery({
        queryKey: ["purchase-cart-pbf"],
        queryFn: getCartDetailsPbf,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 30 * 60 * 1000,
    });
}